import { NumberParam, StringParam } from "use-query-params";

export const FilterModel = {
    stateId: StringParam,
    nicheItemId: NumberParam,
    sort: StringParam,
};
